const faculties = [
  'Agriculture',
  'Arts',
  'Basic Clinical Sciences',
  'Basic Medical Sciences',
  'Clinical Sciences',
  'Communication and Information Sciences',
  'Education',
  'Engineering and Technology',
  'Environmental Sciences',
  'Law',
  'Life sciences',
  'Management Sciences',
  'Pharmaceutical Sciences',
  'Physical Sciences',
  'Social Sciences',
  'Veterinary Medicine',
];

export default faculties;
